import {Component, OnInit, OnDestroy, DoCheck, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ControlContainer, FormsModule, NgForm} from '@angular/forms';
import {PlanModel} from '../../common/service/plan-model.model';
import {selectedPurpose, selectedLodgementType} from '../../lodge-field-record/lodge-field-record.model';
import {NlrPatternDirective} from '../../common/directive/nlr-pattern.directive';
import {NlrFormFieldHasErrorPipe} from '../../common/pipe/nlr-form-field-has-error.pipe';

@Component({
    selector: 'nlr-field-record-wapc',
    imports: [FormsModule, CommonModule, NlrPatternDirective, NlrFormFieldHasErrorPipe],
    templateUrl: './field-record-wapc.component.html',
    styleUrl: './field-record-wapc.component.scss',
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class FieldRecordWapcComponent implements OnInit, DoCheck, OnDestroy {
    planModel: PlanModel = undefined;
    planningApprovalOptions = [];
    previousPurpose = undefined;
    previousLodgeType = undefined;
    referenceNumber = '';
    isRequired = true;
    submitted = false;
    formValid = false;

    @Input()
    model: PlanModel;
    @Input()
    selectedPurpose: selectedPurpose;
    @Input()
    selectedLodgementType: selectedLodgementType;

    ngOnInit(): void {
        if (typeof this.model.planningAuthorityReference === 'undefined') {
            this.model.planningAuthorityReference = {referenceNumber: ''};
        }
    }

    ngDoCheck(): void {
        if (this.model.purpose !== this.previousPurpose || this.model.lodgeType !== this.previousLodgeType) {
            this.previousPurpose = this.model.purpose;
            this.previousLodgeType = this.model.lodgeType;

            const planningApprovalValues = (this.selectedPurpose.planningApproval || '').split(',');
            this.planningApprovalOptions = planningApprovalValues.map(function (v) {
                return {name: v, value: v};
            });

            if (this.model.planningApproval) {
                this.model.planningApproval = '';
            }

            if (this.model.planningAuthorityReference) {
                this.model.planningAuthorityReference = {referenceNumber: ''};
            }

            if (this.planningApprovalOptions.length === 1) {
                this.model.planningApproval = this.planningApprovalOptions[0].value;
            }
        }
    }

    ngOnDestroy(): void {
        // if (this.planModel.planningApproval) {
        //     this.planModel.planningApproval = '';
        // }
        // if (this.planModel.planningAuthorityReference) {
        //     this.planModel.planningAuthorityReference = {referenceNumber: ''};
        // }
    }

    isPlanningAuthorityReferenceRequired() {
        return this.selectedLodgementType && this.selectedLodgementType.applyPlanningAuthorityValidation;
    }

    onPlanningApprovalChange(option: string, planningApproval) {
        this.formValid = planningApproval.valid;
        if (option === 'Exempt') {
            this.referenceNumber = '';
            this.model.planningAuthorityReference = {referenceNumber: ''};
        }
        this.model.planningApproval = option;
    }

    onReferenceChange(newValue: string, planningAuthorityReference) {
        this.formValid = planningAuthorityReference.valid;
        if (this.model.planningAuthorityReference) {
            this.model.planningAuthorityReference.referenceNumber = newValue;
        }
    }

    checkValidity() {
        if (!this.model.planningApproval) {
            this.formValid = false;
        }

        if (this.model.planningApproval !== 'Exempt' && !this.model.planningAuthorityReference.referenceNumber) {
            this.formValid = false;
        }
        return this.formValid;
    }

    isPlanningApprovalOptionValid() {
        return this.model.planningApproval === undefined || this.model.planningApproval === '' ? false : true;
    }
}
